// Copyright (C) 2025 Skylark Drones

export const subscriptionStatus = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  IN_TRIAL: 'in_trial',
  IN_GRACE: 'in_grace',
  CANCEL_SCHEDULED: 'cancel_scheduled',
  FUTURE: 'future'
}

export const InvoiceStatus = {
  PAID: 'paid',
  PAYMENT_DUE: 'payment_due',
  VOIDED: 'voided'
}

export const PaymentMethodType = {
  CASH: 'cash',
  CHECK: 'check',
  BANK_TRANSFER: 'bank_transfer'
}
